import { EMEFieldsName } from "../core/reducers/emeFieldsMapping";

export const EME_FIELDS = {
    SubscriberName              : EMEFieldsName.enName,
    Email                       : EMEFieldsName.emailAddress,
    OLS1_TelNo                  : EMEFieldsName.mobileNumber,
    BR_CR_PI_PN                 : EMEFieldsName.idNo,
    Respect                     : EMEFieldsName.prefix,
    OLS1_ContactPerson          : EMEFieldsName.fullName,
    correspondenceAddress       : EMEFieldsName.residentialAddress,
    emailAddress                : EMEFieldsName.emailAddress,
    OLS1_NameEN                 : EMEFieldsName.enName,
};

export const IDENTITY_TYPE = {
    BR          : 0,
    CR          : 1,
    Passport    : 2,
    HKID        : 3,
    OTHER       : 4,
};

export const SUBSCRIPTION_TYPE = {
    INDIVIDUAL : 0,
    ORGANISATION : 1,
}

export const PAYMENT_METHOD = {
    CHEQUE : 'Cheque',
    BANK_DRAFT : 'BankDraft',
    FPS: 'FPS',
    PPS : 'PPS',
    CREDIT_CARD : 'CreditCard',
    MOBILE_WALLET : 'MobileWallet',
    E_CHEQUE : 'ECheque',
}

export const STRIKABLE_PAYMENT_METHODS = [
    PAYMENT_METHOD.CHEQUE,
    PAYMENT_METHOD.BANK_DRAFT,
    PAYMENT_METHOD.PPS,
    PAYMENT_METHOD.FPS,
    PAYMENT_METHOD.CREDIT_CARD,
    PAYMENT_METHOD.MOBILE_WALLET,
    PAYMENT_METHOD.E_CHEQUE
];